export const distributorImages = {
    basis: 'basis-icon.svg',
    beem: 'beem-icon.svg',
    bmsfcu: 'bmsfcu-icon.svg',
    comfirstcu: 'comfirstcu-icon.svg',
    greenlyne: 'greenlyne-icon.svg',
    happymoney: 'happy-money.svg',
    listo: 'listo-logo.svg',
    microf: 'microf-icon.svg',
    tguc: 'tguc-icon.svg',
    peopledrivencu: 'peopledrivencu-icon.svg',
    qcash: 'qcash-icon.svg',
    splash: 'splash-icon.svg',
    way: 'way.com-icon.svg',
    zirtue: 'zirtue-icon.svg'
};
